
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import util from '@/javascript/util'
import EsQuery from "@/javascript/esQuery";

export default {
components: {
Tab,
TabItem,
},
data () {
return {
sortlog: false,
countlog: false,
showSearch: false,
tabIndex: 0,
specialtyList: [],
placeholder: '搜索景区\\攻略\\游记\\酒店\\美食',
minHeight: 0,
}
},
mounted () {
this.getSpecialtyList()
this.minHeight = document.documentElement.clientHeight;
document.title = this.PAGE_TITLE + "购物"
},
methods: {
showLayer () {
const _this = this
_this.showSearch = true
},



/**
* @msg: 获取特产数据
* @param {*}
* @return {*}
*/
getSpecialtyList () {
let _this = this
const querystring = require('querystring');
const specialtyEsQuery = new EsQuery()
specialtyEsQuery.addSort("sort", specialtyEsQuery.desc, false)
.addPage(0, 10)
const specialtyJsonQuery = JSON.stringify(specialtyEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.produce,
esJsonQuery: specialtyJsonQuery
})).then(res => {
const data = res.data.data
_this.specialtyList = data.map(item => item._source)
})
},

},

}
